<template>
  <header class="app-header">
    
    <b-navbar toggleable="md" type="dark" variant="info">

          <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

          <b-navbar-brand href="#">SiteName</b-navbar-brand>          

          <b-collapse is-nav id="nav_collapse">

            <b-navbar-nav>
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">

              <b-nav-form>
                <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Search"/>
                <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
              </b-nav-form>

              <!-- <b-nav-item href="#/home">Browse</b-nav-item> -->

              <b-nav-item-dropdown right v-if="isLoggedIn()">
                <!-- Using button-content slot -->
                <template slot="button-content">
                  <em>UserName</em>
                </template>
                <b-dropdown-item href="#/dashboard">Dashboard</b-dropdown-item>
                <b-dropdown-item href="#/logout">Signout</b-dropdown-item>
              </b-nav-item-dropdown>

              <b-nav-item href="#/logout" v-if="isLoggedIn()">Signout</b-nav-item>

              <b-nav-item href="#/pages/signin" v-if="!isLoggedIn()">Signin</b-nav-item>

            </b-navbar-nav>

          </b-collapse>
        </b-navbar>

  </header>
</template>
<script>
export default {
  name: 'c-header',
  computed: {
  },
  methods: {
    isLoggedIn () {
      let accessToken = localStorage.getItem('access_token')
      if (accessToken !== null && accessToken !== '') {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SiteHeader.vue